import React from 'react';
import { useTranslation } from 'react-i18next';
import { fetchIllegalWasteDumpsEditHistoryPage } from '../../../state/api/illegalWasteDumpsAPI';
import TableWithFilter from '../../widget/TableWithFilter';
import { dateToString } from '@result/result-ui-components/src/utils/DateUtils';
import unitString from '../../../utils/unitUtil';
import { useParams } from 'react-router';
import { v4 as uuid } from 'uuid';

const EditHistoryList = () => {
	const { id } = useParams();
	const { t } = useTranslation();

	return (
		<>
			<TableWithFilter
				selector={(state) => state.illegalWasteDumpsAPI.history}
				fetchAction={fetchIllegalWasteDumpsEditHistoryPage}
				fetchId={id}
				disableOnClick={true}
				columns={[
					{
						name: t('edited_at'),
						id: 'updateAt',
						cellComponent: (entry) => (
							<div>{dateToString(entry?.changedAt, false, true)}</div>
						),
					},
					{
						name: t('update_by'),
						id: 'updateBy',
						cellComponent: (entry) => <div>{entry?.changedBy}</div>,
					},
					{
						name: t('previous_edit_history'),
						id: 'old',
						disableSort: true,
						cellComponent: (entry) =>
							entry?.old ? <DataList data={entry.old} /> : '/',
					},
					{
						name: t('current_edit_history'),
						id: 'current',
						disableSort: true,
						cellComponent: (entry) =>
							entry?.current ? <DataList data={entry.current} /> : '/',
					},
				]}
			/>
		</>
	);
};

const DataList = ({ data, child = false }) => {
	const { t } = useTranslation();
	const id = uuid();
	const camelToSnakeCase = (str) =>
		str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

	if (data && Object.keys(data).length === 0) return <></>;

	return (
		<ul style={{ maxWidth: '500px' }}>
			{data &&
				Object.keys(data).map(
					(key, index) =>
						key !== 'id' &&
						data[key] !== null && (
							<li key={id + '_' + index} className={child ? 'ml-4' : ''}>
								<span
									className={`pr-1 ${!child ? '' : 'has-text-weight-normal'}`}>
									{t(camelToSnakeCase(key))}:
								</span>
								<span className="has-text-weight-bold">
									{key === 'area' ? (
										unitString('area', data[key])
									) : key === 'volume' ? (
										unitString('volume', data[key])
									) : key === 'status' ? (
										t('waste_dump_type_options.' + data[key])
									) : Array.isArray(data[key]) ? (
										data[key].join(', ')
									) : typeof data[key] === 'object' && data[key] !== null ? (
										<DataList child={true} data={data[key]} />
									) : (
										data[key]
									)}
								</span>
							</li>
						)
				)}
		</ul>
	);
};

export default EditHistoryList;
